import React from 'react'
import { Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const CreateTaskIcon = createIcon({
    viewBox: '0 0 76 64',
    path: (
        <>
            <Path
                fill='currentColor'
                fillRule='nonzero'
                d='M7 2v14h14V2H7zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM7 24v14h14V24H7zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V24a2 2 0 0 1 2-2zM7 46v14h14V46H7zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V46a2 2 0 0 1 2-2z'
            />
            <Rect fill='currentColor' width={40} height={2} x={31} y={8} rx={1} />
            <Rect fill='currentColor' width={40} height={2} x={31} y={30} rx={1} />
            <Rect fill='currentColor' width={12} height={2} x={31} y={52} rx={1} />
            <Path
                fill='currentColor'
                fillRule='nonzero'
                d='M13.531 12L10 9.406l1.149-1.402 2.134 1.566L16.589 6 18 7.166zM13.531 34L10 31.406l1.149-1.402 2.134 1.566L16.589 28 18 29.166zM13.531 56L10 53.406l1.149-1.402 2.134 1.566L16.589 50 18 51.166z'
            />
            <Path
                fill='currentColor'
                fillRule='evenodd'
                d='M64 52h-3v-3a1 1 0 0 0-2 0v3h-3a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 0 0 0-2'
            />
            <Path
                fill='currentColor'
                fillRule='nonzero'
                d='M60 62a9 9 0 1 0 0-18 9 9 0 0 0 0 18zm0 2c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11z'
            />
        </>
    ),
})

CreateTaskIcon.displayName = 'CreateTaskIcon'
